var map = {
	"./chords/czekam-na-ciebie-F.pdf": 332,
	"./chords/moim-pokojem-F.pdf": 554,
	"./chords/nie-patrze-wstecz-C.pdf": 193,
	"./chords/no-longer-slaves-F.pdf": 4078,
	"./chords/selah-F.pdf": 4536,
	"./chords/spiewam-chwala-F.pdf": 9762,
	"./chords/ufac-bede-B.pdf": 1346,
	"./chords/wszystkie-moje-mysli-C.pdf": 5770,
	"./fonts/PragmaticaExtendedBold.otf": 1446,
	"./images/albums/poludnie.jpg": 7840,
	"./images/albums/ufac-bede.png": 9757,
	"./images/side/section_about_XY.jpg": 7858,
	"./images/side/section_find-us.jpg": 2304,
	"./images/side/section_jesus.jpg": 6044,
	"./images/side/section_our-home.jpg": 2462,
	"./images/side/section_support.jpg": 5815,
	"./images/songs/at-the-cross.jpg": 7824,
	"./images/songs/czekam-na-ciebie.jpg": 2421,
	"./images/songs/dawca-drogi.jpg": 5274,
	"./images/songs/dziekczynienie.jpg": 8862,
	"./images/songs/grace-to-grace.jpg": 2776,
	"./images/songs/in-christ-alone.jpg": 2617,
	"./images/songs/it-is-so.jpg": 978,
	"./images/songs/jezus-najwyzsze-imie.jpg": 1901,
	"./images/songs/new-wine.jpg": 1610,
	"./images/songs/nie-patrze-wstecz.jpg": 168,
	"./images/songs/no-longer-slaves.jpg": 4520,
	"./images/songs/only-wanna-sing.jpg": 3460,
	"./images/songs/pelen-laski.jpg": 4204,
	"./images/songs/podroznik.jpg": 2316,
	"./images/songs/prosze-powiedz-panie.jpg": 8617,
	"./images/songs/sinking-deep.jpg": 926,
	"./images/songs/ufac-bede.png": 5913,
	"./images/songs/you-deserve-it.jpg": 9963,
	"./texts/czekam-na-ciebie.pdf": 8104,
	"./texts/in-christ-alone.pdf": 7834,
	"./texts/moim-pokojem.pdf": 6298,
	"./texts/naleze-do-ciebie.pdf": 6832,
	"./texts/nie-patrze-wstecz.pdf": 766,
	"./texts/no-longer-slaves.pdf": 5664,
	"./texts/pelen-laski.pdf": 3734,
	"./texts/prosze-powiedz-panie.pdf": 7356,
	"./texts/selah.pdf": 3270,
	"./texts/spiewam-chwala.pdf": 8029,
	"./texts/ufac-bede.pdf": 3752,
	"./texts/wszystkie-moje-mysli.pdf": 2321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;